var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInbox(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 11,
    viewBox: "0 0 12 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.4766 0.835938C10.3828 0.484375 10.0781 0.25 9.75 0.25H2.25C1.89844 0.25 1.59375 0.484375 1.5 0.8125L0.0703125 6.64844C0.0234375 6.88281 0 7.14062 0 7.375V9.625C0 10.2578 0.492188 10.75 1.125 10.75H10.875C11.4844 10.75 12 10.2578 12 9.625V7.375C12 7.14062 11.9531 6.88281 11.9062 6.64844L10.4766 0.835938ZM8.25 7.75H3.75L3 6.25H1.6875L2.83594 1.75H9.16406L10.2891 6.25H9L8.25 7.75Z",
    fill: "#01000E"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInbox);
export default __webpack_public_path__ + "static/media/inbox.681cff48.svg";
export { ForwardRef as ReactComponent };